import { useCallback, useEffect, useState } from "react"

import { SbEditableBlok } from "@storyblok/storyblok-editable"
import { useStoryblokBridge } from "./context/StoryblokContext"

export const useStoryblok = <T = any>(originalStory: SbEditableBlok, location?: Location | null): { story: SbEditableBlok, content: T } => {
  const bridge = useStoryblokBridge()
  let [story, setStory] = useState(originalStory)
  let [content, setContent] = useState<T>({} as T)

  // We always start off in "SSR mode", to ensure our initial browser render
  // matches the SSR render
  const [isSsr, setIsSsr] = useState(true)

  useEffect(() => {
    // `useEffect` never runs on the server, so we must be on the client if
    // we hit this block
    setIsSsr(false)
  }, [])

  useEffect(() => {
    if (story && typeof story.content === 'string') {
      setContent(JSON.parse(story.content))
    } else {
      if (story) {
        setContent(story.content)
      }
    }

    if (bridge) {
      bridge.on(['input'], (event) => {
        if (event.story.uuid === story.uuid) {
          if (event.story.content) {
            if (typeof event.story.content === 'string') {
              event.story.content = JSON.parse(event.story.content)
            }
          }
  
          setStory(event.story)
        }
      })
    }
  }, [story, bridge])


  if (isSsr && story && typeof story.content === 'string') {
    return { story, content: JSON.parse(story.content) }
  }

  return { story, content }
}

export const resize = (image: string, width: number, height?: number) => {
  const imageService = '//img2.storyblok.com/'
  const actualHeight = height || width
  const path = image.replace(`https://a.storyblok.com`, '')

  return `${imageService}${width}x${actualHeight}${path}`
}
